export default {
  allTracts: (state) => state.tracts,
  tractsLoading: (state) => state.tractsLoading,
  allConversions: (state) => state.conversions,
  allLandownerTypes: (state) => state.landownerTypes,
  allBidCostTypes: (state) => state.bidCostTypes,
  allTimberCategories: (state) => state.timberCategories,
  allTractGroups: (state) => state.tractGroups,
  tractGroupsLoading: (state) => state.tractGroupsLoading,
  chosenTract: (state) => state.chosenTract,
  transitionMode: (state) => state.transitionMode,
  tractTimberVolume: (state) => state.tractTimberVolume,
  standingTimberFilter: (state) => state.standingTimberFilter,
  committedTimberFilter: (state) => state.committedTimberFilter,
  timberPortfolioFilter: (state) => state.timberPortfolioFilter
}
